import * as React from 'react'

const SvgClipboardPencilIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4233_96433)">
      <path
        d="M19.4141 16.6797L18.2422 19.4141L17.0703 16.6797V1.58594C17.0703 1.03365 17.518 0.585938 18.0703 0.585938H18.4141C18.9663 0.585938 19.4141 1.03365 19.4141 1.58594V16.6797Z"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1309 2.92969H19.3455"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91891 2.04391C8.91891 1.23867 8.26617 0.585938 7.46094 0.585938C6.65574 0.585938 6.00297 1.23867 6.00297 2.04391H4.33594V4.38582H10.5859V2.04391H8.91891Z"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 3.20312H12.3359C13.4405 3.20312 14.3359 4.09856 14.3359 5.20312V17.4141C14.3359 18.5186 13.4405 19.4141 12.3359 19.4141H2.58594C1.48137 19.4141 0.585938 18.5186 0.585938 17.4141V5.20313C0.585938 4.09856 1.48137 3.20312 2.58594 3.20312H4.29688"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.27344 7.12024H2.92969V9.46399H5.27344V7.12024Z"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.27344 12.1984H2.92969V14.5421H5.27344V12.1984Z"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39844 7.12024H11.9922"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9922 9.46411H8.39844"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39844 14.5421H11.9922"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39844 12.1984H11.9922"
        stroke="white"
        strokeWidth="1.17188"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4233_96433">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgClipboardPencilIcon
